<script lang="ts">
	import { Background } from "@components/Background.js";
	import CareerForm from "@components/CareerForm.svelte";
	import Ol from "@components/Ol.svelte";
	import { OlSize } from "@components/OlProps.js";
	import Section from "@components/Section.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import Layout from "@components/layout/Layout.svelte";
	import arrowNext from "@core/assets/icons/arrow-next.svg?raw";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { getApplicationToFastestBenefits } from "../data/getApplicationToFastestBenefits.js";
	import type { ApplicationToFastestProps } from "./ApplicationToFastestProps.js";

	const { tenant } = getGlobalTemplateProps();
	const _: ApplicationToFastestProps = $props();
	const anchorForm = "form";
</script>

<Layout>
	<Section background={Background.LightGradient} centered gridHeadline="container-6" gridDesc="container-6" hero>
		{#snippet headline()}
			<Formatted text="Pošli nám svou přihlášku a nastartuj kariéru ve Fastest" />
		{/snippet}
		{#snippet desc()}
			<p>
				<Formatted
					text="Tak co, přidáš se? Stačí vyplnit náš krátký formulář a brzy se ti ozveme. Staň se součástí týmu, kde se oceňuje výkon, inovace a týmový duch."
				/>
			</p>
		{/snippet}
		{#snippet cta()}
			<Link
				variant={ButtonVariant.PhloxOutlineLightBg}
				class="flex items-center justify-center mx-auto mt-2"
				href="#{anchorForm}"
			>
				<Formatted text="Přejít na formulář" />
				<Icon icon={arrowNext} class="ml-2.5 text-fstgrey-900 w-5"></Icon>
			</Link>
		{/snippet}
	</Section>
	<Section
		centered
		gridDesc="row-start-3 xl:row-start-auto container-12 md:container-8 xl:container-start-2 xl:container-end-6 !mt-12 xl:!mt-0"
		gridChildren="container-12 md:container-8 xl:container-start-8 xl:container-end-11"
	>
		{#snippet desc()}
			<CareerForm id={anchorForm} />
		{/snippet}
		<div class="flex flex-col gap-8 text-left">
			<Ol items={getApplicationToFastestBenefits(tenant)} size={OlSize.Medium} />
		</div>
	</Section>
</Layout>
